import { GET_GOODS_MOVEMENT_SITFB } from "../../types";

const initialState = {
    Data: [],
    isAgencyChnage:false,
    loading:false,
    errors:[]
}

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_GOODS_MOVEMENT_SITFB:
			return {
                ...state,
                Data:action.payload,
                errors:[],
                isAgencyChnage:true
              }
        // case SET_ERRORS:
        //         return {
        //             ...state,
        //             errors:action.payload
        //           }
		default:
			return state;
	}
}
